/**
 * Domains that never reach a member: the RFC 2606 example domains (the IMT converter gives migrated
 * accounts with no email `forreston-import-<accountId>@example.com`, because Cognito requires one;
 * cron-be/imt-converter cognito-user-service.ts, #31411) and Ember Tech's no-email domain, which the
 * CFM Guidewire importer uses (`cfm-<accountId>@noemail.embermutuals.com`).
 */
const PLACEHOLDER_EMAIL_DOMAINS = ['example.com', 'example.net', 'example.org', 'noemail.embermutuals.com'];

/**
 * True for an email that can't receive mail (a migration placeholder). Treat it like no email: an
 * invoice "emailed" to it never arrives, so it has to go by letter instead. (#36708)
 */
export function isPlaceholderEmail(email: string | null | undefined): boolean {
  const domain = email?.trim().toLowerCase().split('@')[1];
  return !!domain && PLACEHOLDER_EMAIL_DOMAINS.includes(domain);
}
